import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between px-3.5 py-4 sm:px-6 sm:py-5" }
const _hoisted_2 = { class: "flex flex-col-reverse items-center justify-end sm:flex-row" }
const _hoisted_3 = {
  key: 0,
  class: "p-5 pt-0"
}
const _hoisted_4 = {
  key: 0,
  class: "border-b-2 border-b-cebai-grey-light mb-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-robotoBold mr-2" }, "Guidance", -1)
const _hoisted_6 = { class: "text-cebai-primary p-0.5 border-2 border-cebai-grey-light rounded-full hover:bg-cebai-grey-lightest transition" }
const _hoisted_7 = {
  key: 1,
  class: "md:flex mb-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mr-6 mb-2 md:mb-0 text-cebai-grey-dark text-base" }, " Additional notes: ", -1)
const _hoisted_9 = { class: "sm:flex" }
const _hoisted_10 = {
  key: 0,
  class: "text-base mr-6"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-dark mr-1" }, "Created:", -1)
const _hoisted_12 = {
  key: 1,
  class: "text-base"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-dark mr-1" }, "Last updated:", -1)
const _hoisted_14 = { class: "flex justify-end mt-4 sm:mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_AutoResizeTextarea = _resolveComponent("AutoResizeTextarea")!
  const _component_ChallengeIdeaFavourite = _resolveComponent("ChallengeIdeaFavourite")!
  const _component_ChallengeIdeaMenu = _resolveComponent("ChallengeIdeaMenu")!
  const _component_ArrowUpIcon = _resolveComponent("ArrowUpIcon")!
  const _component_ChallengeIdeaGuidance = _resolveComponent("ChallengeIdeaGuidance")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col w-full rounded-2xl border-2 transition", {
      'border-cebai-primary': _ctx.isSelected,
      'border-cebai-grey-lighter hover:border-cebai-grey-light': !_ctx.isSelected,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-5 h-5 border-2 rounded-md mt-2 mr-3 sm:mr-4 relative transition", {
          'border-cebai-grey-mid hover:border-cebai-grey-dark hover:opacity-50':
            !_ctx.isSelected,
          'border-cebai-primary': _ctx.isSelected,
        }])
      }, [
        _createVNode(_component_CheckIcon, {
          class: _normalizeClass(["text-cebai-primary fill-current absolute -top-1.5 -left-1.5 transition", { 'opacity-0': !_ctx.isSelected, 'opacity-100': _ctx.isSelected }])
        }, null, 8, ["class"])
      ], 2),
      _createVNode(_component_AutoResizeTextarea, {
        ref: "inputDescriptionEl",
        modelValue: _ctx.inputDescription,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputDescription) = $event)),
        readonly: !_ctx.isExpanded || !_ctx.challengeIsActive,
        rows: 1,
        "max-rows": 10,
        class: _normalizeClass(["flex-1 appearance-none pt-1.5 pr-2 sm:pr-4 placeholder-cebai-grey-dark text-cebai-base-dark text-base caret-cebai-primary border-none outline-none w-full resize-none", { 'pointer-events-none': !_ctx.isExpanded || !_ctx.challengeIsActive }])
      }, null, 8, ["modelValue", "readonly", "class"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ChallengeIdeaFavourite, {
          starred: _ctx.starred,
          onClick: _withModifiers(_ctx.handleFavourite, ["stop"])
        }, null, 8, ["starred", "onClick"]),
        _createVNode(_component_ChallengeIdeaMenu, {
          idea: _ctx.idea,
          "expand-idea": _ctx.handleExpand
        }, null, 8, ["idea", "expand-idea"])
      ])
    ]),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.challengeIsActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "flex justify-start items-center mb-3",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleToggleGuidance && _ctx.handleToggleGuidance(...args)))
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_ArrowUpIcon, {
                      class: _normalizeClass(["w-8 h-8 fill-current transition", { 'transform rotate-180': !_ctx.isShowingGuidance }])
                    }, null, 8, ["class"])
                  ])
                ]),
                (_ctx.isShowingGuidance)
                  ? (_openBlock(), _createBlock(_component_ChallengeIdeaGuidance, {
                      key: 0,
                      idea: _ctx.idea,
                      "input-description": _ctx.inputDescription
                    }, null, 8, ["idea", "input-description"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.challengeIsActive || _ctx.inputNotes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_AutoResizeTextarea, {
                  modelValue: _ctx.inputNotes,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputNotes) = $event)),
                  rows: 1,
                  "max-rows": 3,
                  readonly: !_ctx.challengeIsActive,
                  class: "flex-1 appearance-none placeholder-cebai-grey-dark text-cebai-base-dark text-base caret-cebai-primary border-none outline-none w-full resize-none"
                }, null, 8, ["modelValue", "readonly"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.idea.createdAt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getRelativeDateString(_ctx.idea.createdAt)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.idea.updatedAt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getRelativeDateString(_ctx.idea.updatedAt)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.challengeIsActive)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_AppButton, {
                    type: "secondary",
                    class: "mr-3",
                    onClick: _ctx.handleCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_AppButton, {
                    type: "primary",
                    disabled: _ctx.hasInitialDetails,
                    onClick: _ctx.handleUpdate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Update ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ], 64))
              : (_openBlock(), _createBlock(_component_AppButton, {
                  key: 1,
                  type: "secondary",
                  class: "mr-3",
                  onClick: _ctx.handleClose
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Close ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}